import { ErrorResponseSchema } from '@mntn/result'
import { initContract } from '@ts-rest/core'
import { GetNetworksRequestSchema, GetNetworksResponseSchema } from './schemas.ts'

const c = initContract()

export const networksContract = c.router(
  {
    list: c.query({
      method: 'GET',
      path: '/flight-deck/v1/networks',
      description: 'Get networks for filtering',
      request: GetNetworksRequestSchema,
      responses: {
        200: GetNetworksResponseSchema,
        500: ErrorResponseSchema,
      },
    }),
  },
  {
    strictStatusCodes: true,
    commonResponses: {
      403: ErrorResponseSchema,
    },
    metadata: { tags: ['Flight Deck'] },
  },
)

export type NetworksContract = typeof networksContract
